import { ExchangeRunnerPriceSides } from "app/utils/const";
import ENV from "config";
import { api, getDataSimple } from "../helpers/apiHelper";
import { SessionHelper } from "../helpers/sessionHelper";
//
const API_BETS = "/bets";

/**
 * fetch report count
 */
export const fetchCurrentBetsCount = (): any => {
  const url = API_BETS + "/count";
  return getDataSimple(url);
};

/**
 * fetch bets still in processing state
 */
export const fetchProcessingBets = (): any => {
  const url = "/betslip/betslip";
  return getDataSimple(url);
};

/**
 * fetch potential profit
 */
export const fetchPotentialProfit = (
  bet: number,
  odds: number,
  oddsType: string
): any => {
  const url = API_BETS + "/profit";
  const params = {
    "bet-stake": bet,
    "odds-value": odds,
    "odds-type": oddsType,
  };
  return api
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * place bet
 */
export const placeBet = (
  odds: any,
  runnerId: number,
  stake: number,
  oddsType: string,
  request_id: string,
  isWebsocketPrice: boolean,
  isLayBet?: boolean
): any => {
  const url = API_BETS;
  const platform =
    ENV.CSS_THEME !== "GALAXYBET"
      ? SessionHelper.isAsianRouteAndSessionView()
        ? "asian"
        : "euro"
      : "ga3688";

  type Bet = {
    odds: any;
    runnerId: number;
    stake: number;
    side?: string; // Optional property for 'side' in case of lay bet
  };

  const bets: Bet[] = [
    {
      odds,
      runnerId,
      stake,
    },
  ];

  if (isLayBet) {
    bets[0].side = ExchangeRunnerPriceSides.LAY;
  }

  const data = {
    bets,
    platform,
    isWebsocketPrice,
  };

  // Add UUID to the request header when placing a bet, to uniqely identify each POST to /bets endpoint
  const UUIDinterceptor = api.interceptors.request.use(request => {
    request.headers["request_id"] = request_id;
    return request;
  });
  return api
    .post(url, data)
    .then(resp => {
      api.interceptors.request.eject(UUIDinterceptor);
      return resp.data;
    })
    .catch(error => {
      console.log("placeBet error :", error);
      api.interceptors.request.eject(UUIDinterceptor);
      throw error;
    });
};

/**
 * get the status of a placed bet
 */
export const validateBetSlip = (betId: number): any => {
  const url = API_BETS + "/" + betId;
  return getDataSimple(url);
};

/**
 * get the validated exchange bets
 */
export const validatedExchangeBets = (
  oddsValue: number,
  betType: string
): any => {
  const url = API_BETS + "/exchange/validation";
  const data = {
    oddsValue,
    betType,
  };

  return api
    .post(url, data)
    .then(resp => {
      const responseData = resp.data;
      return responseData;
    })
    .catch(error => {
      throw error;
    });
};
